import React, { FC } from 'react';
import styled from 'styled-components';
import { Alert } from '@amzn/storm-ui';

const BannerRow = styled.div`
  width: 100%;
  margin: 0 auto ${({ theme }) => theme.spacing.large.default} auto;
`;

type ErrorMessageProps = {
  message: boolean | string;
};

const ErrorMessage: FC<ErrorMessageProps> = ({ message, ...rest }) => {
  if (!message) {
    return null;
  }

  return (
    <Alert variant="error" className="error" data-message={message} {...rest}>
      {message}
    </Alert>
  );
};

type BannerMessageProps = {
  message: boolean | string;
};

const BannerMessage: FC<BannerMessageProps> = ({ message, ...rest }) => {
  if (!message) {
    return null;
  }

  return (
    <Alert
      variant="success"
      className="success"
      data-message={message}
      {...rest}
    >
      {message}
    </Alert>
  );
};

type BannerSectionProps = {
  error?: ErrorMessageProps;
  banner?: BannerMessageProps;
};

const BannerSection: FC<BannerSectionProps> = ({ error, banner }) => (
  <BannerRow className="banner">
    {error && <ErrorMessage {...error} />}
    {banner && <BannerMessage {...banner} />}
  </BannerRow>
);

export default BannerSection;
